module.exports = __webpack_public_path__ + "static/media/christtheking.86d8df44.webp";